module.exports = __webpack_public_path__ + "0a3a1eb220b6b73005716c4f5a946b89.jpg";